import { useEffect } from "react";

export type UseEffectAsyncArgs = {
  deps?: React.DependencyList;
  effect?: (args: { signal: AbortSignal }) => Promise<any> | void;
  cleanup?: (args: { signal: AbortSignal }) => Promise<any> | void;
  onEffectError?: (error: unknown) => void;
  onEffectFinally?: (args: { signal: AbortSignal }) => void;
  onCleanupError?: (error: unknown) => void;
};

export function useEffectAsync({
  deps,
  effect,
  cleanup,
  onEffectError,
  onEffectFinally,
  onCleanupError,
}: UseEffectAsyncArgs): void {
  useEffect(
    () => {
      const controller = new AbortController();
      const signal = controller.signal;

      effect?.({ signal })
        ?.catch((err) => onEffectError?.(err))
        ?.finally(() => onEffectFinally?.({ signal }));

      return () => {
        controller.abort();
        cleanup?.({ signal })?.catch((err) => onCleanupError?.(err));
      };
    },
    deps?.length ? deps : []
  );
}
